const MOL = 24.45

const EMPTY_OBJECT = {}

const BASE_UNIT_CONFIG = {
  list: [
    ['mg/L', 1000, 'mg/m3', 1000, 'μg/m3', 1000, 'ng/m3'],
    ['ppml', 1000, 'ppm', 1000, 'ppb', 1000, 'ppt'],
    ['kg', 1000, 'g', 1000, 'mg', 1000, 'μg'],
    ['psi', 6.895, 'kpa', 10, 'hpa', 100, 'pa', 0.0075, 'mm hg'],
    ['km', 1000, 'm'],
    ['km/s', 1000, 'm/s'],
    ['m3/s', 3600, 'm3/h', 24, 'm3/d'],
    ['kg/s', 3600, 'kg/h', 24, 'kg/d'],
    ['m/s', 3.6, 'km/h']
  ],
  positive: n => value => value * n,
  negative: n => value => value / n
}

let {list, positive, negative} = BASE_UNIT_CONFIG

const MAPPING_CONFIGS = [{
  list: [list[0], 1, list[1]],
  positive: n => (value, weight, mol = MOL) => value * n / weight * mol,
  negative: n => (value, weight, mol = MOL) => value / n * weight / mol
}]

const UNIT_CONVERTER_MAP = MAPPING_CONFIGS.reduce((map, {list: [inputUnits, n, outputUnits], positive, negative}) => {
  let inputUnitsLen = inputUnits.length
  let outputUnitsLen = outputUnits.length

  for (let i = 0; i < inputUnitsLen; i += 2) {
    let inputUnit = inputUnits[i]
    let subMap = map[inputUnit]
    let n1 = 1

    for (let j = 0; j < outputUnitsLen; j += 2) {
      let outputUnit = outputUnits[j]
      let n2 = n * n1
      subMap[outputUnit] = positive(n2)
      n1 *= outputUnits[j + 1]
      map[outputUnit][inputUnit] = negative(n2)
    }

    n /= inputUnits[i + 1]
  }

  return map
}, list.reduce((map, items) => {
  let realLen = items.length
  let len = realLen - 1

  for (let i = 0; i < len; i += 2) {
    let n = 1
    let inputUnit = items[i]
    let inputSubMap = map[inputUnit]

    if (!inputSubMap) {
      inputSubMap = map[inputUnit] = {}
    }

    for (let j = i + 2; j < realLen; j += 2) {
      let outputUnit = items[j]
      n *= items[j - 1]
      inputSubMap[outputUnit] = positive(n)

      let outputSubMap = map[outputUnit]

      if (!outputSubMap) {
        outputSubMap = map[outputUnit] = {}
      }

      outputSubMap[inputUnit] = negative(n)
    }
  }

  return map
}, {}))

/**
 * 单位转换
 * @param value<Number>       当前值
 * @param inputUnit<String>   当前的单位
 * @param outputUnit<String>  转换后的单位
 * @param otherParams         转换单位需要用到的别的参数
 * @returns {*}<Number>       返回转换后的值
 */
export default (value, inputUnit, outputUnit, ...otherParams) => {
  let unitConverter = (UNIT_CONVERTER_MAP[(inputUnit || '').toLowerCase()] || EMPTY_OBJECT)[(outputUnit || '').toLowerCase()]
  return unitConverter ? unitConverter(value, ...otherParams) : value
}



// WEBPACK FOOTER //
// ./src/utils/unitConverter.js